import { RouterModule, Routes } from '@angular/router';
import { HeaderComponent } from '../Layout/header/header.component'
import { ModuloQRComponent } from '../components/modulo-qr/modulo-qr.component'
import { ItemsComponent } from '../components/items/items.component'
import { UpdateitemComponent } from '../components/items/updateitem/updateitem.component'
import { Updateitem2Component } from '../components/items/updateitem2/updateitem2.component'
import { ItemReviewComponent } from '../components/items/item-review/item-review.component'
import { AsistenciaComponent } from '../components/asistencia/asistencia.component'
import { UsuariosComponent } from '../components/usuarios/usuarios.component'
import { RolesComponent } from '../components/roles/roles.component'
import { NivelComponent } from '../components/Catalogos/nivel/nivel.component';
import { PracticaComponent } from '../components/Catalogos/practica/practica.component';
import { GeneralComponent } from '../components/Catalogos/general/general.component';
import { CatalogoComponent } from '../components/Catalogos/general/catalogo/catalogo.component';
import { SidebarClComponent } from '../Layout/sidebar-cl/sidebar-cl.component'
import { SidebarCoComponent } from '../Layout/sidebar-co/sidebar-co.component'
import { SidebarCoclComponent } from '../Layout/sidebar-cocl/sidebar-cocl.component'
import { ConfigComponent } from '../Layout/sidebar-co/config/config.component'
import { LoginconsultorComponent } from '../components/loginconsultor/loginconsultor.component';
import { from } from 'rxjs';
import { GuardService } from 'src/app/services/login/guard/guard.service';
//#region Prospecto
import { ProspectoComponent } from '../Layout/sidebar-co/prospecto/prospecto.component';
import { NuevoProspectoComponent } from '../Layout/sidebar-co/prospecto/nuevo-prospecto/nuevo-prospecto.component';
import { ProspectoFtComponent } from '../Layout/sidebar-co/prospecto/prospecto-ft/prospecto-ft.component';
import { ProspectoNotifComponent } from '../Layout/sidebar-co/prospecto-notif/prospecto-notif.component';
//#endregion
//#region Reclamo
import { ReclamoComponent } from '../Layout/sidebar-co/reclamo/reclamo.component';
import { NuevoReclamoComponent } from '../Layout/sidebar-co/reclamo/nuevo-reclamo/nuevo-reclamo.component';
import { ReclamoFtComponent } from '../Layout/sidebar-co/reclamo/reclamo-ft/reclamo-ft.component';
import { ReclamoNotifComponent } from '../Layout/sidebar-co/reclamo-notif/reclamo-notif.component';
//#endregion
import { ClientComponent } from '../Layout/sidebar-co/client/client.component';
import { FtComponent } from '../Layout/sidebar-cocl/ft/ft.component';
import { ItemSublistCoclComponent } from '../Layout/sidebar-cocl/ft/item-sublist-cocl/item-sublist-cocl.component';
import { TarifasComponent } from '../Layout/sidebar-cocl/ft/tarifas/tarifas.component';
import { ClientQrComponent } from '../Layout/sidebar-cocl/ft/client-qr/client-qr.component';
import { NuevoClientComponent } from '../components/nuevo-client/nuevo-client.component';
import { DashboardComponent } from '../Layout/sidebar-cl/dashboard/dashboard.component';
import { ItemSublistComponent } from '../Layout/sidebar-cl/dashboard/item-sublist/item-sublist.component';
import { DashboardcoComponent } from '../Layout/sidebar-co/dashboardco/dashboardco.component';
import { DashboardAreaComponent } from '../Layout/sidebar-co/dashboardco/dashboard-area/dashboard-area.component';
import { DashboardEmpresaComponent } from '../Layout/sidebar-co/dashboardco/dashboard-empresa/dashboard-empresa.component';
import { DetalleComponent } from '../Layout/sidebar-co/dashboardco/dashboard-empresa/detalle/detalle.component';
import { ResumenComponent } from '../Layout/sidebar-co/dashboardco/dashboard-empresa/resumen/resumen.component';
import { AlertasComponent } from '../Layout/sidebar-cl/alertas/alertas.component';
import { ReactivoClComponent } from '../Layout/sidebar-cl/alertas/reactivo-cl/reactivo-cl.component';
import { AlertaCoComponent } from '../Layout/sidebar-co/alerta-co/alerta-co.component';
import { ItemlistCoComponent } from '../Layout/sidebar-co/alerta-co/itemlist-co/itemlist-co.component';
import { ReactivoCoComponent } from '../Layout/sidebar-co/alerta-co/itemlist-co/reactivo-co/reactivo-co.component';
import { TipoContratoComponent } from '../components/Catalogos/tipo-contrato/tipo-contrato.component';
import { AlertaContratoComponent } from '../components/contrato/alerta-contrato/alerta-contrato.component';
import { ContratoComponent } from '../components/contrato/contrato.component';
import { ContratoSublistComponent } from '../components/contrato/contrato-sublist/contrato-sublist.component';
//#region Reportes
import { ReporteAdminComponent } from '../components/reporte-admin/reporte-admin.component';
import { ReporteIngresoComponent } from '../components/reporte-ingreso/reporte-ingreso.component';
import { LogUsuariosComponent } from '../components/reportes/log-usuarios/log-usuarios.component';
import { DirectorioGeneralComponent } from '../components/reportes/directorio-general/directorio-general.component';
import { EstatusCargaComponent } from '../components/reportes/estatus-carga/estatus-carga.component';
import { OpinionCumplimientoComponent } from '../components/reportes/opinion-cumplimiento/opinion-cumplimiento.component';
import { EstatusContratoComponent } from '../components/reportes/estatus-contrato/estatus-contrato.component';
import { LegalInfoContratoComponent } from '../components/reportes/legal-info-contrato/legal-info-contrato.component';
import { SeguridadVisitaCertComponent } from '../components/reportes/seguridad-visita-cert/seguridad-visita-cert.component';
import { TipoUnidadComponent } from '../components/reportes/tipo-unidad/tipo-unidad.component';
import { OrigenDestinoComponent } from '../components/reportes/origen-destino/origen-destino.component';
import { CodigoConductaComponent } from '../components/reportes/codigo-conducta/codigo-conducta.component';
import { DocumentosAuditoriaComponent } from '../components/reportes/documentos-auditoria/documentos-auditoria.component';
//#endregion
import { TarifasTransportistaComponent } from '../Layout/sidebar-cl/tarifas-transportista/tarifas-transportista.component';
import { AlertasTarifasComponent } from '../Layout/sidebar-co/alertas-tarifas/alertas-tarifas.component';
import { InfoQRComponent } from '../components/info-qr/info-qr.component'
import { InfomultipleQRComponent } from '../components/infomultiple-qr/infomultiple-qr.component'
import { ConfigNoticiasComponent } from '../Layout/sidebar-co/config-noticias/config-noticias.component';
import { UpdateNoticiasComponent } from '../Layout/sidebar-co/config-noticias/update-noticias/update-noticias.component';
import { NoticiasComponent } from '../Layout/sidebar-co/noticias/noticias.component';


const app_routes:Routes=[    
    //Módulo 1: Change Management
    { path: '', component: LoginconsultorComponent },
    { path: 'info-qr/:id', component: InfoQRComponent },
    { path: 'infomultiple-qr/:id', component: InfomultipleQRComponent },
    { path: 'sa-rm', component: HeaderComponent,canActivate:[GuardService], children: [
   
      { path:'items', component:ItemsComponent },
      { path: 'updateitem/:item', component: UpdateitemComponent },
      { path: 'updateitem2/:item', component: Updateitem2Component },
      { path: 'itemreview/:id', component: ItemReviewComponent },
      { path: 'alertareactcl/:id', component: ReactivoClComponent },
      { path: 'alertareactco/:id', component: ReactivoCoComponent },

      { path:'usuarios', component:UsuariosComponent },
      { path: 'rol', component: RolesComponent },
      { path: 'area', component: NivelComponent },
      { path: 'grupo', component: PracticaComponent },
      { path: 'general', component: GeneralComponent },
      { path: 'catalog/:id', component: CatalogoComponent },
      { path: 'tipo-contrato', component: TipoContratoComponent },

      { path: 'nuevoprospect', component: NuevoProspectoComponent },
      { path: 'nuevocliente', component: NuevoClientComponent },
      { path: 'nuevoreclamo', component: NuevoReclamoComponent },
    
      { path: 'client', component: SidebarClComponent, children: [
        { path: 'alertas/:id', component: AlertasComponent},
        { path: 'dashboard', component: DashboardComponent},
        { path: 'itemsublist/:id', component: ItemSublistComponent},
        { path: 'asistencia', component: AsistenciaComponent },
        { path: 'tarifas', component: TarifasTransportistaComponent },
        { path: 'noticias', component: NoticiasComponent }
       ]
      },

      { path: 'admin', component: SidebarCoComponent, children: [  
        { path: 'alertas/:id', component: AlertaCoComponent},     
        { path: 'alertaitem/:id', component: ItemlistCoComponent},     
         { path: 'config', component: ConfigComponent },
         { path: 'codes-qr', component:ModuloQRComponent },
//#region Reportes
         { path: 'reporte-admin', component: ReporteAdminComponent },
         { path: 'reporte-ingreso', component: ReporteIngresoComponent },
         { path: 'reportes-log-usuarios', component: LogUsuariosComponent },
         { path: 'reportes-directorio-general', component: DirectorioGeneralComponent },
         { path: 'reportes-estatus-carga', component: EstatusCargaComponent },
         { path: 'reportes-opinion-cumplimiento', component: OpinionCumplimientoComponent },
         { path: 'reportes-estatus-contrato', component: EstatusContratoComponent },
         { path: 'reportes-legal-infocont', component: LegalInfoContratoComponent },
         { path: 'reportes-seguridad-visitacert', component: SeguridadVisitaCertComponent },
         { path: 'reportes-tipo-unidad', component: TipoUnidadComponent },
         { path: 'reportes-origen-destino', component: OrigenDestinoComponent },
         { path: 'reportes-codigo-conducta', component: CodigoConductaComponent },
         { path: 'reportes-documentos-auditoria', component: DocumentosAuditoriaComponent },
//#endregion
         { path: 'prospect', component: ProspectoComponent },
         { path: 'prospect-ft/:id', component: ProspectoFtComponent },
         { path: 'prospect-notif/:tipo', component: ProspectoNotifComponent },
         
         { path: 'reclamo', component: ReclamoComponent },
         { path: 'reclamo-ft/:id', component: ReclamoFtComponent },
         { path: 'reclamo-notif', component: ReclamoNotifComponent },

         { path: 'client/:deleted', component: ClientComponent },

         { path: 'dashboard/:id', component: DashboardcoComponent },
         { path: 'dashboard-area/:id', component: DashboardAreaComponent },
         { path: 'dashboard-empresa/:id', component: DashboardEmpresaComponent },
         { path: 'dashboard-detalle/:id', component: DetalleComponent },
         { path: 'dashboard-resumen/:id', component: ResumenComponent },

         { path: 'asistencia', component: AsistenciaComponent },
         { path: 'alerta-contrato', component: AlertaContratoComponent },
         { path: 'alerta-tarifa', component: AlertasTarifasComponent },
         { path: 'config-noticias', component: ConfigNoticiasComponent },
         { path: 'update-noticias/:id', component: UpdateNoticiasComponent },
         { path: 'noticias', component: NoticiasComponent }
        ]
      },

      { path: 'admin-client/:id', component: SidebarCoclComponent, children: [
        { path: 'ft/:id', component: FtComponent },
        { path: 'contrato/:id', component: ContratoComponent },
        { path: 'contrato-sublist/:id', component: ContratoSublistComponent },
        { path: 'itemsublist/:id', component: ItemSublistCoclComponent},
        { path: 'tarifa/:id', component: TarifasComponent},
        { path: 'client-qr/:id', component: ClientQrComponent}
       ]
      }

     ]
    },
    { path: '**', pathMatch: 'full', redirectTo:''}//'/valuescan/consultor/client' }
]

export const AppRouting=RouterModule.forRoot(app_routes);